// extracted by mini-css-extract-plugin
export var actionButton = "_77-1";
export var actionButtons = "_77-2";
export var actions = "_77-0";
export var aiUnread = "_77-10";
export var alignCenter = "_77-h";
export var backWrapper = "_77-3";
export var cellContainer = "_77-4";
export var checkboxContainer = "_77-5";
export var contentContainer = "_77-6";
export var contentHeader = "_77-8";
export var conversationsTableWrapper = "_77-s";
export var draftReplyBadgeContainer = "_77-m";
export var dropdownItem = "_77-b";
export var dropdownItemsContainer = "_77-a";
export var dropdownTitle = "_77-c";
export var errorIcon = "_77-7";
export var filter = "_77-d";
export var gray = "_77-i";
export var headerActionButtons = "_77-e";
export var headerCheckboxContainer = "_77-f";
export var icon = "_77-j";
export var menuContainer = "_77-k";
export var noMoreTicketsIcon = "_77-12";
export var noMoreTicketsSubText = "_77-13";
export var oneLine = "_77-l";
export var optionsButton = "_77-n";
export var plus = "_77-o";
export var portalButtonsWrapper = "_77-g";
export var red = "_77-p";
export var scrolledTop = "_77-9";
export var search = "_77-q";
export var selectedConversationsCount = "_77-r";
export var spinner = "_77-t";
export var strong = "_77-u";
export var summaryCell = "_77-v";
export var tableContainer = "_77-11";
export var tagContainer = "_77-w";
export var threeDots = "_77-x";
export var twoLines = "_77-y";
export var unread = "_77-z";